// Textos COMPARTIDOS: componentes de UI reutilizables (ModuleHeader, ChipFilter,
// SearchToggle, diálogos de useUiAlert), el cliente HTTP, la campanita y el
// shell (App.tsx). Ver src/i18n/textos.ts.
import { defineTextos } from '../textos.ts';

export const textosComun = defineTextos({
  // --- Botones y acciones genéricas (ui-alert-context, module-header) ------
  cerrar: 'Cerrar',
  cancelar: 'Cancelar',
  eliminar: 'Eliminar',
  confirmar: 'Confirmar',
  guardar: 'Guardar',
  nuevo: 'Nuevo',
  buscar: 'Buscar',
  buscarPuntos: 'Buscar…',
  recargar: 'Recargar',

  // --- Toasts automáticos de la API (ui-alert-context) -----------------------
  notificaciones: 'Notificaciones',
  sesionExpiradaTitulo: 'Tu sesión expiró',
  sesionExpiradaDesc: 'Volvé a entrar para seguir trabajando.',
  sinConexionServidor: 'No hay conexión con el servidor',
  errorDelServidor: 'Error {status} del servidor',
  falloInterno: 'fallo interno',

  // --- ModuleHeader / SearchToggle / ChipFilter ------------------------------
  ocultarBusqueda: 'Ocultar búsqueda',
  buscarEnModulo: 'Buscar en el módulo',
  enVivo: 'EN VIVO',
  pestanas: 'Pestañas',
  limpiarBusqueda: 'Limpiar búsqueda',
  cerrarBusqueda: 'Cerrar búsqueda',
  ordenarPor: 'Ordenar por',
  ordenar: 'Ordenar',
  desplazarIzquierda: 'Desplazar a la izquierda',
  desplazarDerecha: 'Desplazar a la derecha',

  // --- Campanita (use-notifications) -----------------------------------------
  sinNombre: 'sin nombre',

  // --- Cliente HTTP (api/client.ts): mensajes que arma el propio cliente -----
  noSeConectoBackend: 'No se pudo conectar al backend en {base}: {error}',
  noRespondioATiempo: 'el servidor no respondió en {s} s',
  noSeConfirmoGuardado: 'No se pudo confirmar si quedó guardado: el servidor no respondió. Revisa el pedido antes de repetirlo.',
  credencialesInvalidas: 'Credenciales inválidas',
  sesionExpiroVolve: 'Tu sesión expiró. Volvé a entrar.',
  necesitasIniciarSesion: 'Necesitás iniciar sesión.',
  sinDetalle: 'sin detalle',
  errorDesconocido: 'Error desconocido',

  // --- Shell (App.tsx) -------------------------------------------------------
  entornoPruebasDev: 'ENTORNO DE PRUEBAS · DEV',
  entornoLocal: 'ENTORNO LOCAL',
  datosNoReales: ' — los datos y las facturas no son reales',
  usuarioOContrasenaIncorrectos: 'Usuario o contraseña incorrectos',
  quickLoginNoConfigurado: 'Quick login no configurado para: {id}',
}, {
  cerrar: 'Close',
  cancelar: 'Cancel',
  eliminar: 'Delete',
  confirmar: 'Confirm',
  guardar: 'Save',
  nuevo: 'New',
  buscar: 'Search',
  buscarPuntos: 'Search…',
  recargar: 'Reload',

  notificaciones: 'Notifications',
  sesionExpiradaTitulo: 'Your session expired',
  sesionExpiradaDesc: 'Sign in again to keep working.',
  sinConexionServidor: 'No connection to the server',
  errorDelServidor: 'Server error {status}',
  falloInterno: 'internal failure',

  ocultarBusqueda: 'Hide search',
  buscarEnModulo: 'Search in this module',
  enVivo: 'LIVE',
  pestanas: 'Tabs',
  limpiarBusqueda: 'Clear search',
  cerrarBusqueda: 'Close search',
  ordenarPor: 'Sort by',
  ordenar: 'Sort',
  desplazarIzquierda: 'Scroll left',
  desplazarDerecha: 'Scroll right',

  sinNombre: 'no name',

  noSeConectoBackend: 'Could not connect to the backend at {base}: {error}',
  noRespondioATiempo: 'the server did not answer within {s} s',
  noSeConfirmoGuardado: 'Could not confirm it was saved: the server did not answer. Check the order before repeating it.',
  credencialesInvalidas: 'Invalid credentials',
  sesionExpiroVolve: 'Your session expired. Sign in again.',
  necesitasIniciarSesion: 'You need to sign in.',
  sinDetalle: 'no detail',
  errorDesconocido: 'Unknown error',

  entornoPruebasDev: 'TEST ENVIRONMENT · DEV',
  entornoLocal: 'LOCAL ENVIRONMENT',
  datosNoReales: ': data and invoices are not real',
  usuarioOContrasenaIncorrectos: 'Wrong username or password',
  quickLoginNoConfigurado: 'Quick login not configured for: {id}',
});
